export default "__VITE_ASSET__CxWi1JLb__"